import React from 'react';
import { Modal, Button, ButtonEnums } from 'components/atoms';
import styled from 'styled-components/macro';

/**
 * CIMA Exam: Waive Exam Modal
 * @category CIMA Membership
 * CBUILD-389
 */

interface Props {
  open: boolean;
  onClose(): void;
  onConfirm(): void;
  isLoading?: boolean;
}

export const ConfirmWaiveExamModal: React.FC<Props> = ({ open, onClose, onConfirm, isLoading }) => {
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      heading="Are you sure you want to waive your exam exemption?"
      testId="confirmation-details-modal"
      showCloseCross={!isLoading}
      cancelNode={
        <Button
          size={ButtonEnums.sizes.small}
          variant={ButtonEnums.variants.secondary}
          testId="cancel-resignation"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancel
        </Button>
      }
      confirmNode={
        <Button
          size={ButtonEnums.sizes.small}
          testId="confirm-resignation"
          variant={ButtonEnums.variants.primary}
          onClick={onConfirm}
          loading={isLoading}
        >
          Confirm
        </Button>
      }
    >
      Waived exemptions cannot be reclaimed.
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  &&&& {
    width: ${props => props.theme.pxToRem(590)};
    background: ${props => props.theme.colors.neutralWhite};
    margin-top: ${props => props.theme.pxToRem(48)};
    border-radius: ${props => props.theme.pxToRem(2)};
    box-sizing: border-box;

    ${props => props.theme.mediaQueries.mobileOnly} {
      width: 90%;
      margin-left: auto;
      margin-right: auto;
    }

    .content {
      margin: 0 !important;
      text-align: center;
      padding: ${props => props.theme.pxToRem(28)} 0 ${props => props.theme.pxToRem(32)} !important;
    }

    > .header {
      margin: ${props => props.theme.pxToRem(-14)} auto 0;
      text-align: center;
      display: table;
      h2 {
        margin: 0 auto;
        font-size: ${props => props.theme.fontSizes.l};
      }
    }
  }

  button > svg {
    fill: ${props => props.theme.colors.primaryDarkPurple};
  }
`;
